(function () {
    'use strict';

    angular.module('iMatApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$scope', '$timeout', '$window', '$q', 'eventService', 'modelService', 'userCartService', 'offlinePriceRequestService',
        'upload3DModelTrackEventsService', 'mainWorkflow', 'modelTabWorkflow', 'upload3DModelSettings', 'mainWorkspace'
    ];

    function MainController($scope, $timeout, $window, $q, eventService, modelService, userCartService, offlinePriceRequestService,
            trackEventsService, mainWorkflow, modelTabWorkflow, settings, mainWorkspace) {
        var vm = this;

        vm.tab = 'model';
        vm.cartItemCreationSource = 1;
        vm.isPosting = false;
        vm.isMedSite = settings.isMedSite;
        vm.addToCart = addToCart;
        vm.proceedToCheckout = proceedToCheckout;
        vm.createColdPrintLikeViewModel = createColdPrintLikeViewModel;

        eventService.subscribe($scope, 'RequestPrice', onRequestPrice);
        eventService.subscribe($scope, 'AcceptRepair', onAcceptRepair);
        eventService.subscribe($scope, 'DeclineRepair', onDeclineRepair);
        eventService.subscribe($scope, 'RefreshProduct', onRefreshProduct);

        activate();

        // ----------------------------------- Public functions -----------------------------

        function activate() {
            mainWorkflow.setup($scope);
        }

        function addToCart(product) {
            if (!product.isReady()) {
                return null;
            }

            return $q.resolve(0)
                .then(function () {
                    vm.isPosting = true;
                })
                .then(function () {
                    var coldPrintLikeViewModel = createColdPrintLikeViewModel(product);
                    return userCartService.addColdPrintLikeProducts(coldPrintLikeViewModel, true)
                        .catch(function (reason) {
                            throw new Upload3DModelGeneralError('Add to cart failed.', reason);
                        });
                })
                .finally(function () {
                    vm.isPosting = false;
                });
        }

        function proceedToCheckout(product) {
            if (!product.isReady()) {
                return null;
            }

            return $q.resolve(0)
                .then(function () {
                    vm.isPosting = true;
                })
                .then(function () {
                    var coldPrintLikeViewModel = createColdPrintLikeViewModel(product);
                    return userCartService.addColdPrintLikeProducts(coldPrintLikeViewModel, false)
                        .catch(function (reason) {
                            throw new Upload3DModelGeneralError('Add to cart failed.', reason);
                        });
                })
                .then(function () {
                    $window.location.href = settings.cartPageUrl;
                })
                .catch(function (reason) {
                    vm.isPosting = false;
                    return $q.reject(reason);
                });
        }

        function onRequestPrice(product) {
            vm.isPosting = true;

            return $q.resolve(0)
                .then(function () {
                    vm.isPosting = true;
                })
                .then(function () {
                    return offlinePriceRequestService.requestPrice(product.getProductInfo())
                        .catch(function (reason) {
                            throw new Upload3DModelGeneralError('Can not create OPR.', reason);
                        });
                })
                .then(function () {
                    $window.location.href = settings.oprPageUrl;
                })
                .catch(function (reason) {
                    vm.isPosting = false;
                    return $q.reject(reason);
                });
        }

        function onAcceptRepair(product) {
            if (!product.model.isNeedToApproveRepairModel()) {
                return $q.resolve(0);
            }

            if (!isPreviewGeneratedForFixedModel(product.model)) {
                eventService.notify("HighlightMessage_GeneretingPreviewForFixedModel");
                return $q.resolve(0);
            }

            return acceptRepair(product);
        }

        function onDeclineRepair(product) {
            if (!product.model.isNeedToApproveRepairModel()) {
                return $q.resolve(0);
            }

            if (!isPreviewGeneratedForFixedModel(product.model)) {
                eventService.notify("HighlightMessage_GeneretingPreviewForFixedModel");
                return $q.resolve(0);
            }

            return declineRepair(product);
        }
        
        function onRefreshProduct() {
            return modelTabWorkflow.refresh();
        }

        // ----------------------------------- Private functions -----------------------------

        function createColdPrintLikeViewModel(product) {
            return {
                CurrencyID: mainWorkspace.options.currencyId,
                ProductInfos: [product.getProductInfo()],
                CartItemCreationSource: vm.cartItemCreationSource
            };
        }

        function acceptRepair(product) {

            trackEventsService.trackAcceptDeclineV3RepairResults(true);

            return modelService.acceptRepair(product.model.id)
                .then(function () {
                    modelTabWorkflow.refresh();
                })
                .catch(function (reason) {
                    throw new Upload3DModelGeneralError('Accept repair model is failed.', reason);
                });
        }

        function declineRepair(product) {

            trackEventsService.trackAcceptDeclineV3RepairResults(false);

            return modelService.declineRepair(product.model.id)
                .then(function () {
                    modelTabWorkflow.refresh();
                })
                .catch(function (reason) {
                    throw new Upload3DModelGeneralError('Decline repair model is failed.', reason);
                });
        }

        function isPreviewGeneratedForFixedModel(model) {
            return !model.isPreviewGenerating && !model.isPreviewGeneratingFailed;
        }
    }
})();